import React from 'react';
import { LoginPagesManager } from '@qualifio/sso-proxy-ui';
import { QlfTitle, useQlfTranslation } from '@qualifio/ui-commons';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DetailForm } from '../../shared/layout/DetailForm';
import { QlfMasterDetailContainer } from '../../shared/layout/QlfMasterDetailContainer';
import { useAccounts } from '../../accounts/AccountsContext';
import { useApi } from '../../shared/api-client/ApiClientProvider';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  title: {
    textAlign: 'center',
    justifyItems: 'center',
  },
  description: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  content: {
    marginLeft: spacing(1),
    marginRight: spacing(1),
  },
}));

export function LoginPagesDetails() {
  const classes = useStyles();
  const { t } = useQlfTranslation('translation');
  const { ssoProxyApi, ssoProxyIntegrationApiClient } = useApi();
  const { currentAccount } = useAccounts();
  return (
    <QlfMasterDetailContainer isAccountLevel>
      <DetailForm>
        <DetailForm.Form className={classes.content}>
          <div className={classes.title}>
            <QlfTitle variant="h2" separator={{ state: 'center' }}>
              {t('login-pages.edition.title')}
            </QlfTitle>
          </div>
          <div className={classes.description}>{t('login-pages.edition.description')}</div>
          <LoginPagesManager
            enabled={true}
            ssoProxyApiClient={ssoProxyApi}
            integrationApiClient={ssoProxyIntegrationApiClient}
            ownerId={`LOY:${currentAccount.id}`}
          />
        </DetailForm.Form>
      </DetailForm>
    </QlfMasterDetailContainer>
  );
}
